










import Vue from "vue";

export default Vue.extend({
  name: "vc-plan-option-store-and-bank-icon-for-2dev-offer",
  props: {
    currency: { default: undefined }
  }
});
